import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	experience: null,
	experiences: [],
	errorMessage: null,
	navigation: null,
};

export default function experiencesReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_EXPERIENCES_SUCCESS:
			return Object.assign({}, state, {
				experiences: action.experiences,
			});
		case ActionTypes.LOAD_EXPERIENCES_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.LOAD_EXPERIENCE_SUCCESS:
			return Object.assign({}, state, {
				experience: action.experience,
			});
		case ActionTypes.EDIT_EXPERIENCE_NAVIGATION_SUCCESS:
			return Object.assign({}, state, {
				navigation: action.navigation,
			});
		case ActionTypes.LOAD_EXPERIENCE_NAVIGATION_SUCCESS:
			return Object.assign({}, state, {
				navigation: action.navigation,
			});
		case ActionTypes.LOAD_EXPERIENCE_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		default:
			return state;
	}
}
